import { AxiosResponse } from 'axios';

import { CreateCommentRequestType } from './types';

import { CommonResponseType } from 'api/authApi';
import { authServiceClient } from 'config';
import { CommentType } from 'state/reducers/inspections/types';

export const createCommentRequest = (data: CreateCommentRequestType) => {
  return authServiceClient.post<
    CommentType,
    AxiosResponse<CommentType>,
    CreateCommentRequestType
  >(`/inspection-comment`, data);
};

export const deleteCommentRequest = (id: string) => {
  return authServiceClient.delete<CommonResponseType, AxiosResponse<CommonResponseType>>(
    `/inspection-comment/${id}`,
  );
};
